import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';
import {getStatus} from 'redux-resource';
import {readCollection} from '../../../redux/actions/collections';
import {readFiles} from '../../../redux/actions/files';
import {setTitle} from '../../../redux/actions/page';
import {FILE_TYPE_VIDEO} from '../../../components/common/types';
import FilesPage from './files';

function mapStateToProps(state, props) {
	const {
		match: {params: {collectionId} = {}} = {}
	} = props;
	// const collectionId = props.match.params.collectionId;
	const status = getStatus(state, `collections.meta[${collectionId}].readStatus`);
	const collection = state.collections.resources[collectionId];

	return {
		status,
		collection
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		readCollection() {
			const {
				match: {params: {collectionId} = {}} = {}
			} = props;

			dispatch(readCollection(collectionId))
				.then(collections => collections[0])
				.then(collection => dispatch(setTitle(collection.name)));
			dispatch(readFiles(collectionId));
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentWillMount() {
			this.props.readCollection();
		}
	}),
	withHandlers({
		handleOpenFile: props => (fileId, type) => {
			const {
				match: {params: {collectionId} = {}} = {},
				history
			} = props;

			if (type === FILE_TYPE_VIDEO) {
				history.push(`/collections/${collectionId}/video/${fileId}`);
			} else {
				history.push(`/collections/${collectionId}/doc/${fileId}`);
			}
		}
	}),
	mapProps(props => {
		const {
			match,
			location,
			staticContext,
			collection,
			history,
			...rest
		} = props;

		return {
			...rest,
			collection: collection || {},
			collectionId: match.params.collectionId
		};
	})
);

export default enhance(FilesPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/files/index.js